<h2 mat-dialog-title>Dissocier ma licence</h2>
<mat-dialog-content class="mat-typography">
  Attention, votre compte va être dissocié avec votre licence. Certaines informations ne seront plus accessibles. <br>
  Souhaitez-vous réellement dissocier votre licence ?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close class="back">Annuler</button>
  <button [mat-dialog-close]="true" cdkFocusInitial class="confirm" (click)="dissociate()">Confirmer</button>
</mat-dialog-actions>